import { PlusIcon } from 'lucide-react'

import { Button } from '@/components/button'

interface Props {
    onClick: () => void
}

export default function EmptyApiKeys({ onClick }: Props) {
    return (
        <div className="flex flex-col items-center justify-center py-8">
            <PlusIcon className="h-10 w-10" />
            <h5 className="mb-4 font-thin">You haven't created any API Keys yet</h5>
            <Button onClick={onClick}>Create one</Button>
        </div>
    )
}
